__turbopack_context__.v({
  "activeItem": "yllr_G_activeItem",
  "gridList": "yllr_G_gridList",
  "highlight-result": "yllr_G_highlight-result",
  "list": "yllr_G_list",
  "listItem": "yllr_G_listItem",
  "outpagination": "yllr_G_outpagination",
  "pagination": "yllr_G_pagination",
  "result": "yllr_G_result",
  "title": "yllr_G_title",
});
